import { useState } from "react";
import { Accordion, AccordionBody, AccordionHeader, AccordionItem, Col, Container, Row } from "reactstrap";
import { FAQData } from "../../../Data/Bonus/FAQ";
import { dynamicImage, Image } from "../../../Utils";
import PageImage from "../../CommonComponents/PageImage";

const FAQContainer = () => {
  const [open, setOpen] = useState<string>("1");
  const toggle = (id: string) => (open === id ? setOpen("") : setOpen(id));
  return (
    <section className="section-py-space faq-section">
      <PageImage />
      <Container>
        <Row className="faq-pages">
          <Col lg="10" xs="12" className="offset-lg-2">
            <Row className="faq-block">
              <Col xs="12" className="position-relative">
                <div className="faq-title">
                  <h2>Frequently Asked Questions</h2>
                  <p>Discover you question from underneath or present your inquiry fromt tahe submit box.</p>
                </div>
              </Col>
              <Col xs="12">
                <Accordion open={open} toggle={toggle} className="template-accordion">
                  {FAQData.map((item, index) => (
                    <AccordionItem key={index} className="card faq-block accordion template-accordion">
                      <AccordionHeader targetId={item.id} className="card-header accordion-header">
                        {item.accordionHeading}
                      </AccordionHeader>
                      <AccordionBody accordionId={item.id}>{item.bodyText}</AccordionBody>
                    </AccordionItem>
                  ))}
                </Accordion>
              </Col>
            </Row>
          </Col>
          <Image className="img-fluid" src={dynamicImage("faq.svg")} alt="faq-img" />
        </Row>
      </Container>
    </section>
  );
};

export default FAQContainer;
